import ReactPlayer from 'react-player';
import { Button, Card } from 'reactstrap';
import React from 'react';
import ImageGallery from 'react-image-gallery';
import picUpload from '../../assets/images/assets/upload.png';
import './pic-in-product.scss';
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
  useSortable,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';


const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Tắt ảnh phóng to
    </div>
  );
};

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Bật ảnh phóng to
    </div>
  );
};

const SortablePicture = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children({ attributes, listeners })}
    </div>
  );
};

const SortablePictureList = ({ productId, pictures, renderPicture, onOpenUpload, onDragEnd }) => {
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
    >
      <SortableContext items={pictures.map(picture => picture.url)} strategy={rectSortingStrategy}>
        <div className="list-pictures">
          {pictures.map(picture =>
            <SortablePicture key={`${productId}-${picture.url}`} id={picture.url}>
              {({ attributes, listeners }) => renderPicture(picture, true, { attributes, listeners })}
            </SortablePicture>
          )}
          <Card className="card-picture" onClick={() => onOpenUpload(productId)}><img src={picUpload} /></Card>
        </div>
      </SortableContext>
    </DndContext>
  );
};

class PicInProduct extends React.Component {
  constructor(props) {
    super(props);
  }

  removePic = (url) => {
    const { onChange, productId, pictures } = this.props;
    onChange(productId, pictures.filter(picture => picture.url !== url));
  }

  onDragEnd = ({ active, over }) => {
    const { onChange, productId, pictures } = this.props;
    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = pictures.findIndex(picture => picture.url === active.id);
    const newIndex = pictures.findIndex(picture => picture.url === over.id);
    if (oldIndex === -1 || newIndex === -1) {
      return;
    }

    onChange(productId, arrayMove(pictures, oldIndex, newIndex));
  }

  renderPicture = (picture, isShowDelete = true, dragHandleProps = null) => {
    return (
      <Card
        className="card-picture"
        style={{ position: 'relative' }}
      >
        {picture.type === 'image' ?
          <img className="border" src={picture.url} width="100%" height="100%" />
          : ''}
        {picture.type === 'video' ?
          <ReactPlayer
            controls={!isShowDelete}
            muted={true}
            playsinline={true}
            volume={0}
            loop={false}
            width="100%"
            height="100%"
            url={picture.url}
          />
          : ''}
        {isShowDelete ?
          <div style={{
            position: 'absolute',
            top: 2,
            left: 2,
            height: 20,
            width: 20,
            zIndex: 9000,
            background: 'none',
          }}>
            <Button
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
              }}
              onClick={() => {
                this.removePic(picture.url)
              }} className="btn-link btn-danger"
            >
              <i className="text-danger fa fa-trash"></i></Button>
          </div>
          : null}
        {dragHandleProps ?
          <div
            {...dragHandleProps.attributes}
            {...dragHandleProps.listeners}
            style={{
              position: 'absolute',
              top: 2,
              right: 2,
              height: 20,
              width: 20,
              zIndex: 1000,
              touchAction: 'none',
              cursor: 'grab',
            }}
          >
            <i className="text-primary fa fa-bars"></i>
          </div>
          : null}
      </Card>
    )
  }


  render() {
    const { productId, pictures, onOpenUpload } = this.props;
    return (
      <div>
        <div>
          <ImageGallery

            items={pictures.map(picture => ({
              renderItem: () => this.renderPicture(picture, false)
            }))}
            showPlayButton={false}
            showFullscreenButton={false}
          />
        </div>

        <SortablePictureList
          productId={productId}
          pictures={pictures}
          renderPicture={this.renderPicture}
          onOpenUpload={onOpenUpload}
          onDragEnd={this.onDragEnd}
        />
      </div>
    )
  }
}

export default PicInProduct
